/**
 * Tracks report history by route name.
 *
 * Provides methods to find, add and remove route models from history.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Collection from "../collections/report-history";

const channel = Radio.channel("report");

class ReportingHistory extends Marionette.Object {
  initialize() {
    // create collection
    this.collection = new Collection();

    // setup listeners
    this.listenTo(channel, "history:add", this._add);
    this.listenTo(channel, "history:remove", this._remove);

    channel.reply("history:find", this._find, this);
  }

  _add(model) {
    // target route
    const route = model.getRoute();

    // clone current state
    const state = this.collection.clone();

    // does the route exist?
    const found = state.findWhere({ route });
    if (found) {
      // replace it
      state.remove(found);
    }

    // insert it
    state.add(model);

    // update state
    this.collection.set(state.toJSON());

    //console.info("history:add", this.collection.toJSON());
  }

  /**
   * Looks up a model in the collection by route and removes it if found.
   */
  _remove(route) {
    const found = this._find(route);
    if (found) {
      this.collection.remove(found);
      //console.warn("history:removed", route);
    }
  }

  /**
   * Looks up a model in the collection by route and returns it if found.
   * Otherwise a null is returned.
   */
  _find(route) {
    const found = this.collection.findWhere({ route });

    // console.warn("history:find %s", route, found);

    return found ? found : null;
  }
}

export { ReportingHistory as default };
